function parseRegexPattern(pattern: string): RegExp {
  // Check if pattern is in /pattern/flags format
  const regexLiteralMatch = pattern.match(/^\/(.+)\/([gimsuy]*)$/);

  if (regexLiteralMatch) {
    const [, regexBody, flags] = regexLiteralMatch;
    return new RegExp(regexBody, flags);
  }

  return new RegExp(pattern);
}

/**
 * Validates a tracking ID input value against a regex pattern
 * @param input - The tracking ID to validate
 * @param regexPattern - The regex pattern to validate against (from preferences)
 * @returns true if valid or no validation needed, false if invalid
 */
export function validateTrackingIdFormat(
  input: string,
  regexPattern: string | undefined
): boolean {
  if (!regexPattern || !input) {
    return true;
  }

  try {
    const regex = parseRegexPattern(regexPattern);
    return regex.test(input);
  } catch (error: unknown) {
    console.error("Invalid regex pattern in preferences:", error);
    //If regex is invalid don't block user
    return true;
  }
}


